// extracted by mini-css-extract-plugin
export default {"zoomModal":"A0-z"};